import { Routes } from '@angular/router';
import { authGuard, SPECTRUM_HELP_ROUTES } from 'common';

export const routes: Routes = [
    {
        path: 'validate',
        loadComponent: () => import('./validate/validate.component').then(m => m.ValidateComponent)
    },
    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('./layout/screens.component').then(m => m.ScreensComponent),
        children: [
            // The Help centre: this module's manual and Getting around Spectrum.
            ...SPECTRUM_HELP_ROUTES,
            { path: '', redirectTo: 'overview', pathMatch: 'full' },
            {
                path: 'overview',
                loadComponent: () => import('./screens/overview/overview.component').then(m => m.OverviewComponent)
            },
            {
                path: 'directory',
                loadComponent: () => import('./screens/directory/directory.component').then(m => m.DirectoryComponent)
            },
            {
                path: 'onboard',
                loadComponent: () => import('./screens/onboard/onboard.component').then(m => m.OnboardComponent)
            },
            {
                path: 'approvals',
                loadComponent: () => import('./screens/approvals/approvals.component').then(m => m.ApprovalsComponent)
            },
            {
                path: 'calendar',
                loadComponent: () => import('./screens/calendar/calendar.component').then(m => m.CalendarComponent)
            },
            {
                path: 'balances',
                loadComponent: () => import('./screens/balances/balances.component').then(m => m.BalancesComponent)
            },
            {
                path: 'substitutions',
                loadComponent: () => import('./screens/substitutions/substitutions.component').then(m => m.SubstitutionsComponent)
            },
            {
                path: 'org-chart',
                loadComponent: () => import('./screens/org-chart/org-chart.component').then(m => m.OrgChartComponent)
            },
            {
                path: 'transfers',
                loadComponent: () => import('./screens/transfers/transfers.component').then(m => m.TransfersComponent)
            },
            {
                path: 'bulk-edit',
                loadComponent: () => import('./screens/bulk-edit/bulk-edit.component').then(m => m.BulkEditComponent)
            },
            {
                path: 'import',
                loadComponent: () => import('./screens/import/import.component').then(m => m.ImportComponent)
            },
            {
                path: 'compliance',
                loadComponent: () => import('./screens/compliance/compliance.component').then(m => m.ComplianceComponent)
            },
            {
                path: 'reports',
                loadComponent: () => import('./screens/reports/reports.component').then(m => m.ReportsComponent)
            },
            {
                path: 'audit',
                loadComponent: () => import('./screens/audit/audit.component').then(m => m.AuditComponent)
            },
            {
                path: 'settings',
                loadComponent: () => import('./screens/settings/settings.component').then(m => m.SettingsComponent)
            },
            {
                path: 'employees/:id',
                loadComponent: () => import('./screens/employee-360/employee-360.component').then(m => m.Employee360Component)
            }
        ]
    },
    { path: '**', redirectTo: '' }
];
